import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <span style={s.brand}>📦 JSMSTOCK.COM</span>
        <span style={s.sep}>|</span>
        <Link to="/terms"   style={s.link}>Terms</Link>
        <span style={s.sep}>|</span>
        <Link to="/privacy" style={s.link}>Privacy</Link>
        <span style={s.sep}>|</span>
        <Link to="/refund"  style={s.link}>Refund</Link>
        <span style={s.sep}>|</span>
        <span style={s.copy}>© 2026 Madurai, Tamil Nadu</span>
      </div>
    </footer>
  );
}

const s = {
  footer:{
    background:'#2C3E50',
    padding:'12px 20px',
    marginTop:'auto',
  },
  inner:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexWrap:'wrap',
    gap:'8px',
    maxWidth:'1100px',
    margin:'0 auto',
  },
  brand:{color:'#C9A84C',fontWeight:'700',fontSize:'13px',fontFamily:'Arial'},
  sep:{color:'rgba(255,255,255,0.3)',fontSize:'12px'},
  link:{
    color:'rgba(255,255,255,0.75)',
    textDecoration:'none',
    fontSize:'13px',
    fontFamily:'Arial',
    fontWeight:'500',
  },
  copy:{color:'rgba(255,255,255,0.4)',fontSize:'12px',fontFamily:'Arial'},
};
